<script setup lang="ts">
import { type NotivueItem } from 'notivue';
import BaseToast, { type NotivueItemProps } from './BaseToast.vue';

interface Props {
  item: NotivueItem<NotivueItemProps>;
}

defineProps<Props>();
</script>

<template>
  <BaseToast :item="item">
    <template #icon>
      <span
        :class="{ '!bg-system-success-light p-1': item.title, 'h-full': !item.title }"
        class="flex items-center justify-center rounded-md"
      >
        <IconifyIcon
          :icon="item.title ? `heroicons:check-circle` : `heroicons:check-circle-solid`"
          class="size-6 text-system-success-green"
        ></IconifyIcon>
      </span>
    </template>
    <template #content>
      <h3 v-if="item.title" class="mb-1 text-base font-medium leading-4">
        {{ item.title }}
      </h3>
      <div
        :class="{ 'font-medium !text-system-success-dark': !item.title }"
        class="text-sm"
        :role="item.ariaRole"
        :aria-live="item.ariaLive"
        v-safe-html="item.message"
      />
    </template>
  </BaseToast>
</template>

<style scoped lang="scss"></style>
